import { useEffect } from 'react';
import { hookstate, useHookstate } from '@hookstate/core';
import { useEspot } from '~/store/Query/api';

export const pickupInStoreState = hookstate(false);

export const cuotaState = hookstate({
  banks: [],
  affiliations: [],
  cuotas: null,
});

export const formCustom = new Set([
  'dpiConfirm',
  'document_type',
  'id',
  'nit',
  'day',
  'month',
  'year',
  'departamentoid',
  'municipioid',
  'pobladoid',
]);

export const formShipping = new Set([
  'first_name',
  'last_name',
  'address_line_1',
  'phone_1',
  'state_or_province_name',
  'city',
  'address_line_2',
  'email_1',
  'allowed_recipient_1',
  'fax_1',
]);

export const sessionInfo = () => {
  const sessionCustom = Array.from(formCustom).reduce((acc, key) => {
    const value = sessionStorage.getItem(`form_custom_info.${key}`);
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {});
  const sessionShipping = Array.from(formShipping).reduce((acc, key) => {
    const value = sessionStorage.getItem(`form_shipping_info.${key}`);
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {});
  const sessionBilling = [
    'address_line_1',
  ].reduce((acc, key) => {
    const value = sessionStorage.getItem(`form_billing_info.${key}`);
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {});
  return { sessionCustom, sessionShipping, sessionBilling };
};

export const useFormOrder = () => {
  const config = useEspot('formularios-direcciones');
  const state = useHookstate();
  useEffect(() => {
    if (config.data?.ok) {
      state.set(config.data.body);
    }
  }, [config.data]);
  return state;
};

export const locationState = hookstate({
  loading: false,
  use: false,
  retry: 0,
  showError: false,
  latitud: null,
  longitud: null,
  granted: false,
});
